import { z } from 'zod';

const baseUrl = window.location.origin;
const apiBaseUrl = baseUrl.replace('insights', 'api');
const portalBaseUrl = baseUrl.replace('insights', 'portal');

const envSchema = z
  .object({
    VITE_API_BASE_URL: z.string().url().catch(apiBaseUrl),
    VITE_PORTAL_BASE_URL: z.string().url().catch(portalBaseUrl),
  })
  .transform((data) => ({
    API_BASE_URL: data.VITE_API_BASE_URL,
    PORTAL_BASE_URL: data.VITE_PORTAL_BASE_URL,
    SUPPORT_EMAIL: 'bestservice@mend.com',
    MUI_LICENSE_KEY:
      '18f3f5977834f0e333dc9355f6da5d1fTz0xMTMzNTUsRT0xNzc5NDk0Mzk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMy0yMDI0LEtWPTI=',
  }));

export const config = envSchema.parse(import.meta.env);
